import * as React from 'react';

import { Checkbox } from '@rematter/ui-web';
import { cn } from '@rematter/ui-web/lib';

import { useTranslations } from '~/modules/trade/i18n/useTranslations';

interface Props {
  selectedDocuments: {
    salesOrder: boolean;
    shippingSummary: boolean;
  };
  onDocumentSelect: (
    documentType: 'salesOrder' | 'shippingSummary',
    checked: boolean,
  ) => void;
}

export const SalesOrderTabDocumentsRow: React.FC<Props> = ({
  selectedDocuments,
  onDocumentSelect,
}) => {
  const t = useTranslations();

  return (
    <div className="@SalesOrderTabDocumentsRow flex w-full flex-row items-center gap-4 py-2">
      <div className="flex h-[45px] w-[150px] items-center gap-2 rounded-md bg-neutral/5 p-3">
        <span className="text-base font-bold">
          {t.salesOrderDetail.documents.labels.salesOrder}
        </span>
      </div>

      {/* Sales Order Document */}
      <div
        className={cn(
          'flex h-[45px] w-[140px] cursor-pointer items-center gap-2 rounded-md border p-3',
          selectedDocuments.salesOrder
            ? 'border-[2px] border-primary/80 shadow-[0_0_0_2px_var(--color-primary/20)]'
            : 'border-neutral/10',
        )}
        onClick={() =>
          onDocumentSelect('salesOrder', !selectedDocuments.salesOrder)
        }
      >
        <Checkbox
          isSelected={selectedDocuments.salesOrder}
          className="pointer-events-none"
        >
          <div className="text-base text-neutral/80">
            {t.salesOrderDetail.documents.types.salesOrder}
          </div>
        </Checkbox>
      </div>

      {/* Shipping Summary Document */}
      <div
        className={cn(
          'flex h-[45px] min-w-[140px] cursor-pointer items-center gap-2 rounded-md border p-3',
          selectedDocuments.shippingSummary
            ? 'border-[2px] border-primary/80 shadow-[0_0_0_2px_var(--color-primary/20)]'
            : 'border-neutral/10',
        )}
        onClick={() =>
          onDocumentSelect(
            'shippingSummary',
            !selectedDocuments.shippingSummary,
          )
        }
      >
        <Checkbox
          isSelected={selectedDocuments.shippingSummary}
          className="pointer-events-none"
        >
          <div className="text-base text-neutral/80">
            {t.salesOrderDetail.documents.types.shippingSummary}
          </div>
        </Checkbox>
      </div>
    </div>
  );
};
